import React, { useState } from "react";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList, LinkItem } from "../../../../components/links/Links";
import UserAvatar from "../../../../components/user/UserAvatar";
import { useTheme, useThemeUpdate } from "../../../provider/Theme";
import { decrypt, findUpper } from "../../../../utils/Utils";
import { useNavigate } from "react-router";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PreviewAltCard,
  TooltipComponent,
} from "../../../../components/Component";

const User = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const themeUpdate = useThemeUpdate();
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);
  const token = localStorage.getItem("accessToken");
  const encryptedData = localStorage.getItem("userDetail");
  const userData = encryptedData ? decrypt(encryptedData) : null;

  const handleLogout = () => {
    localStorage.clear();
    navigate("/auth-login");
  };

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar icon="user-alt" className="sm" />
          <div className="user-info d-none d-md-block">
            <div className="user-status text-capitalize">{userData?.role}</div>
            <div className="user-name dropdown-indicator text-capitalize">
              {userData?.name
                ? userData.name.split(" ").slice(0, 2).join(" ") + (userData.name.split(" ").length > 2 ? "..." : "")
                : ""}
            </div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar">
              <span className="text-uppercase">{findUpper(userData?.name)}</span>
            </div>
            <div className="user-info">
              {/* <span className="lead-text text-capitalize">{userData?.name}</span> */}
              <span
                className="lead-text text-capitalize"
                style={{
                  display: "block",
                  maxWidth: "200px", // adjust based on UI
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {userData?.name}
              </span>
              {/* <span className="sub-text">{userData?.email}</span> */}
              <span
                className="sub-text"
                style={{
                  display: "block",
                  maxWidth: "200px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {userData?.email}
              </span>
            </div>
          </div>
        </div>
        {/* <div className="dropdown-inner">
          <LinkList>
            <LinkItem link="/user-profile-regular" icon="user-alt" onClick={toggle}>
              View Profile
            </LinkItem>
            <LinkItem link="/user-profile-setting" icon="setting-alt" onClick={toggle}>
              Account Setting
            </LinkItem>
            <LinkItem link="/user-profile-activity" icon="activity-alt" onClick={toggle}>
              Login Activity
            </LinkItem>
            <li>
              <a className={`dark-switch ${theme.skin === 'dark' ? 'active' : ''}`} href="#" 
              onClick={(ev) => {
                ev.preventDefault();
                themeUpdate.skin(theme.skin === 'dark' ? 'light' : 'dark');
              }}>
                {theme.skin === 'dark' ? 
                  <><em className="icon ni ni-sun"></em><span>Light Mode</span></> 
                  : 
                  <><em className="icon ni ni-moon"></em><span>Dark Mode</span></>
                }
              </a>
            </li>
          </LinkList>
        </div> */}
        <div className="dropdown-inner">
          <LinkList>
            <a style={{ cursor: "pointer" }} onClick={handleLogout}>
              <Icon name="signout"></Icon>
              <span>Sign Out</span>
            </a>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;
